import { VERSION_RECEIVED } from './actionTypes';

export const versionReceived = (version) => {
    return {
        type: VERSION_RECEIVED,
        version,
    };
};
